/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Price_NoneInputs */

const en_lesson_price_none = /** @type {(inputs: Lesson_Price_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const he_lesson_price_none = /** @type {(inputs: Lesson_Price_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

/**
* | output |
* | --- |
* | "—" |
*
* @param {Lesson_Price_NoneInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_price_none = /** @type {((inputs?: Lesson_Price_NoneInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Price_NoneInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_price_none(inputs)
	return he_lesson_price_none(inputs)
});